import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-black/20 p-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_3 = { class: "ml-4" }
const _hoisted_4 = { class: "text-sm font-medium text-white" }

import { computed, ComputedRef } from 'vue';

import { UserModel } from '@/types';
import { useAuthStore } from '@/stores';


export default /*@__PURE__*/_defineComponent({
  __name: 'TemplateProfile',
  setup(__props) {

const authStore = useAuthStore();
const user: ComputedRef<UserModel | undefined> = computed(() => authStore.userModel);

return (_ctx: any,_cache: any) => {
  const _component_UiGravatar = _resolveComponent("UiGravatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (user.value !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_UiGravatar, {
              email: user.value.email,
              name: user.value.name,
              class: "inline-block h-10 w-10 rounded-full"
            }, null, 8, ["email", "name"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(user.value.name), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})